// src/components/Layout.tsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Toast from './Toast';
import '../styles/Layout.css';

const Layout: React.FC = () => {
  const [toastMessage, setToastMessage] = useState('');
  const location = useLocation();

  // Clear toast on route change
  useEffect(() => {
    setToastMessage('');
  }, [location]);

  return (
    <div className="layout-root">
      <Navbar />
      <main className="layout-main">
        {/* Pass setToastMessage to children via context or props if needed */}
        <Outlet context={{ setToastMessage }} />
      </main>
      <Footer />
      {toastMessage && <Toast message={toastMessage} />}
    </div>
  );
};

export default Layout;